import { useEffect, useState } from "react";

const navItems = [
  { label: "人物档案", href: "#archive" },
  { label: "关系脉络", href: "#relation" },
  { label: "身份深挖", href: "#background" },
  { label: "讨论区", href: "#discussion" },
  { label: "常见问题", href: "#faq" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/90 backdrop-blur-md"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="flex w-full items-center justify-between px-5 py-3.5 md:px-10">
        <a href="#hero" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-user-search-line text-lg" />
          </span>
          <h1 className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              海角黑料
            </span>
            <span className="mt-0.5 font-label text-[10px] tracking-[0.2em] text-foreground-500">
              人物脉络梳理站
            </span>
          </h1>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-md px-3.5 py-2 font-label text-sm text-foreground-700 transition-colors duration-200 hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <span className="flex items-center gap-1.5 rounded-full border border-background-200 px-3 py-1.5 font-label text-xs text-foreground-600">
            <i className="ri-refresh-line text-sm text-accent-500" />
            更新 2026.09.10
          </span>
          <a
            href="#archive"
            className="whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 font-label text-sm text-background-50 transition-colors duration-200 hover:bg-foreground-800"
          >
            开始梳理
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航"
          onClick={() => setOpen((prev) => !prev)}
          className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-5 pb-5 pt-2 lg:hidden">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between border-b border-background-100 py-3 font-label text-sm text-foreground-800"
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-400" />
              </a>
            ))}
          </nav>
          <a
            href="#archive"
            onClick={() => setOpen(false)}
            className="mt-4 flex w-full items-center justify-center rounded-md bg-foreground-950 px-4 py-2.5 font-label text-sm text-background-50"
          >
            开始梳理
          </a>
        </div>
      )}
    </header>
  );
}